import React from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';

const LoadingSpinner = ({ message = "Loading...", size = "border", variant = "primary" }) => {
  return (
    <Container className="my-4">
      <Row>
        <Col>
          <div className="text-center">
            <Spinner animation={size} variant={variant} role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <p className="mt-2 text-muted">{message}</p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default LoadingSpinner;
